module.exports = __webpack_public_path__ + "static/media/VU.3b3fcfb4.svg";